'use client';

import React, { createContext, useContext, useState, ReactNode } from 'react';

type SignalCountContextType = {
  totalSignalCount: number | null;
  setTotalSignalCount: (count: number | null) => void;
  companySignalCount: number | null;
  setCompanySignalCount: (count: number | null) => void;
  contactSignalCount: number | null;
  setContactSignalCount: (count: number | null) => void;
  marketSignalCount: number | null;
  setMarketSignalCount: (count: number | null) => void;
  linkedInSignalCount: number | null;
  setLinkedInSignalCount: (count: number | null) => void;
};

const SignalCountContext = createContext<SignalCountContextType | undefined>(undefined);

export function SignalCountProvider({ children }: { children: ReactNode }) {
  const [totalSignalCount, setTotalSignalCount] = useState<number | null>(null);
  const [companySignalCount, setCompanySignalCount] = useState<number | null>(null);
  const [contactSignalCount, setContactSignalCount] = useState<number | null>(null);
  const [marketSignalCount, setMarketSignalCount] = useState<number | null>(null);
  const [linkedInSignalCount, setLinkedInSignalCount] = useState<number | null>(null);

  return (
    <SignalCountContext.Provider
      value={{
        totalSignalCount,
        setTotalSignalCount,
        companySignalCount,
        setCompanySignalCount,
        contactSignalCount,
        setContactSignalCount,
        marketSignalCount,
        setMarketSignalCount,
        linkedInSignalCount,
        setLinkedInSignalCount,
      }}
    >
      {children}
    </SignalCountContext.Provider>
  );
}

export function useSignalCount() {
  const context = useContext(SignalCountContext);
  if (!context) throw new Error('useSignalCount must be used within a SignalCountProvider');
  return context;
}
